var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33955 18.3816L25.6056 1.47786L48.8717 18.3816L39.9848 45.7325H11.2264L2.33955 18.3816Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5625 19.9062C14.5625 18.6118 15.6118 17.5624 16.9062 17.5624H34.0938C35.3882 17.5624 36.4375 18.6118 36.4375 19.9062C36.4375 21.2006 35.3882 22.2499 34.0938 22.2499H16.9062C15.6118 22.2499 14.5625 21.2006 14.5625 19.9062ZM16.9062 19.1249C16.4748 19.1249 16.125 19.4747 16.125 19.9062C16.125 20.3377 16.4748 20.6874 16.9062 20.6874H34.0938C34.5252 20.6874 34.875 20.3377 34.875 19.9062C34.875 19.4747 34.5252 19.1249 34.0938 19.1249H16.9062Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5625 32.4062C14.5625 31.1118 15.6118 30.0624 16.9062 30.0624H34.0938C35.3882 30.0624 36.4375 31.1118 36.4375 32.4062C36.4375 33.7006 35.3882 34.7499 34.0938 34.7499H16.9062C15.6118 34.7499 14.5625 33.7006 14.5625 32.4062ZM16.9062 31.6249C16.4748 31.6249 16.125 31.9747 16.125 32.4062C16.125 32.8377 16.4748 33.1874 16.9062 33.1874H34.0938C34.5252 33.1874 34.875 32.8377 34.875 32.4062C34.875 31.9747 34.5252 31.6249 34.0938 31.6249H16.9062Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 21.4687C16.125 21.0372 16.4748 20.6874 16.9062 20.6874H34.0938C34.5252 20.6874 34.875 21.0372 34.875 21.4687V30.8437C34.875 31.2752 34.5252 31.6249 34.0938 31.6249H16.9062C16.4748 31.6249 16.125 31.2752 16.125 30.8437V21.4687ZM17.6875 22.2499V30.0624H33.3125V22.2499H17.6875Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 33.1874C25.751 33.1874 25.9867 33.308 26.1335 33.5115L29.5165 38.199C29.769 38.5489 29.69 39.0372 29.3401 39.2897C28.9903 39.5422 28.5019 39.4633 28.2494 39.1134L25.5 35.3037L22.7506 39.1134C22.4981 39.4633 22.0098 39.5422 21.6599 39.2897C21.3101 39.0372 21.2311 38.5489 21.4836 38.199L24.8665 33.5115C25.0134 33.308 25.2491 33.1874 25.5 33.1874Z",
    fill: "#555555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5447 23.2845C31.8362 23.6026 31.8147 24.0968 31.4967 24.3883L26.8092 28.6852C26.5371 28.9346 26.1275 28.9596 25.8272 28.745L23.5907 27.1476L21.3209 29.0931C20.9933 29.3739 20.5001 29.336 20.2193 29.0084C19.9385 28.6808 19.9765 28.1876 20.3041 27.9068L23.0385 25.563C23.3113 25.3291 23.7085 25.3116 24.001 25.5205L26.2201 27.1056L30.4409 23.2365C30.7589 22.945 31.2531 22.9665 31.5447 23.2845Z",
    fill: "#3D8ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.b2ba7008beeac72a7256944993e9672e.svg";
export { ForwardRef as ReactComponent };